import {useState} from "react";

const Slider = (props) => {
    const state = props.state;
    const text = props.text;
    const update = props.update;
    const type = props.type;
    const elem = props.elem;

    function handleSliderClick() {
        update(!state);
    }

    return (
        <>
            <div className="slider">
                <div className={state ? "slider-container on" : "slider-container off"} tabIndex="0"
                     onClick={handleSliderClick}>
                    <div className={state ? "slider-button on" : "slider-button off"}/>
                </div>
                <div className="slider-text">{elem ? elem : text}</div>
            </div>
        </>
    )
}

export default Slider